var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-763.000000, -2757.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/Camera",
    transform: "translate(763.000000, 2757.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.625,6.85714286 L18.1875,6.85714286 L15.85,3.51428571 C15.575,3.25714286 15.1625,3 14.75,3 L9.25,3 C8.8375,3 8.425,3.25714286 8.15,3.51428571 L5.8125,6.85714286 L2.375,6.85714286 C1.55,6.85714286 1,7.37142857 1,8.14285714 L1,19.7142857 C1,20.4857143 1.55,21 2.375,21 L21.625,21 C22.45,21 23,20.4857143 23,19.7142857 L23,8.14285714 C23,7.37142857 22.45,6.85714286 21.625,6.85714286 Z M12,17.4 C9.73333333,17.4 8,15.645 8,13.35 C8,11.055 9.73333333,9.3 12,9.3 C14.2666667,9.3 16,11.055 16,13.35 C16,15.645 14.2666667,17.4 12,17.4 Z",
    id: "Fill",
    fill: "#858199",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/iconCamera.59d930a7.svg";
export { ForwardRef as ReactComponent };